export default "./images/survio-1-pTo-assets-text_answer.png";